import React from 'react'
import {useState} from 'react'
import { CREATE_VIDEO } from '../../../../../../graphql-client/Mutation';
import { useMutation } from '@apollo/client';
import {LIST_VIDEO_USER_MANAGE} from '../../../../../../graphql-client/Queries';
import ComponentUploadFileToS3 from '../../../../../../uploadToS3/ComponentUploadFileToS3';
export default React.memo(function FormTitleVideo(props) {
  const [isDocumentUploading, setIsDocumentUploading] = useState(false);
  const handleDismissButtonClick = (e) => {
    e.currentTarget.blur();
  };
  
    const [formState, setFormState] = useState({
        description: '',
        title:'',
        document:'',
        tags:'',
        urlDocument:''
      });
      
     const [createVideo] = useMutation(
        CREATE_VIDEO, 
        {
          variables: {
            description: formState.description,
            url: props.urlVideo,
            title:formState.title,
            document:formState.urlDocument,
            thumbnail:props.thumbnail,
            videoListId:props.videoListId,
            tags: formState.tags
          },
          update: (cache, {data:{createVideo}})=>{
            cache.modify({
              query: LIST_VIDEO_USER_MANAGE,
              id: cache.identify({ __typename: 'VideoList', id: props.videoListId }),
              fields: {
                countVideo(existingCountVideoRefs, { readField }) {
                  return existingCountVideoRefs +1;
                },
                video(existingVideosRefs, { toReference }) {
                  const newVideoRef = toReference({
                    __typename: 'Video',
                    id: createVideo.id,
                  });
                  return [newVideoRef,...existingVideosRefs];
                },
              },
            });
            },
        }
      );

      const hasPublishData = Boolean(formState.title.trim() || props.urlVideo || props.thumbnail);
      const canSubmit = hasPublishData && !props.isVideoUploading && !isDocumentUploading;
    
      const handleSubmit = async (e)=> {
        e.preventDefault();

        if (props.isVideoUploading) {
          alert('Video đang tải lên. Vui lòng chờ tải lên hoàn tất rồi xuất bản.');
          return;
        }

        if (isDocumentUploading) {
          alert('Tài liệu đang tải lên. Vui lòng chờ tải lên hoàn tất rồi xuất bản.');
          return;
        }

        if (!hasPublishData) {
          alert('Để xuất bản, vui lòng có ít nhất một trong các dữ liệu: tiêu đề, video hoặc ảnh đại diện.');
          return;
        }

        await createVideo();
        setFormState({...formState, description: '', title:'', document:'',tags:'', thumbnail:'',urlDocument:''});
        props.setUrl();
        alert('Đã thêm học liệu mới thành công')
      };

    return (
      <div className="">
        <form onSubmit={handleSubmit}>   
            {/* <div className="modal-body"> */}
                    <div className="mb-3">
                      <label 
                      htmlFor="titleNewVideo-from"
                        className="col-form-label">
                        <b>Tiêu đề của học liệu</b>  
                      </label>
                      <input 
                          className="form-control" id="titleNewVideo-from" rows="2" 
                        value={formState.title}
                            onChange={(e) =>
                            setFormState(
                              {
                                ...formState,
                                title: e.target.value
                              }
                            )
                          } 
                      />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="docsNewVideo-from" className="col-form-label">
                         <b>Gắn thẻ học liệu</b> 
                        </label>
                        <textarea 
                            id="docsNewVideo-from"  
                            value={formState.tags}
                            className="form-control"  
                            rows="2" cols="50" 
                            placeholder="Ví dụ: #toan8 #hoctoan #thaydaytoan"
                            onChange={
                              (e) =>
                              setFormState({
                                  ...formState,
                                  tags: e.target.value
                              })
                            } 
                        />
                    </div>
                              
                    <div className="mb-3">
                      <label htmlFor="descriptionNewVideo-from" className="col-form-label">
                       <b>Miêu tả học liệu</b> 
                      </label>
                      <textarea 
                          id="descriptionNewVideo-from" 
                          value={formState.description}
                          className="form-control"  
                          rows="4" cols="50" 
                          placeholder="Nhập vào mô tả học liệu/tài liệu"
                        onChange={
                            (e) =>
                            setFormState({
                                ...formState,
                                description: e.target.value
                            })
                          }
                      />
                    </div>
                    <hr />
                    <div className="mb-3">
                        <label htmlFor="docsNewVideo-from" className="col-form-label">
                         <b>Thêm tài liệu</b>
                        </label>
                        <ComponentUploadFileToS3
                          formState={formState}
                          setFormState={setFormState}
                          onUploadStatusChange={setIsDocumentUploading}
                        ></ComponentUploadFileToS3>
                        
                    </div>
                    
            {/* </div>  */}
            <div className="modal-footer">
              <button type="button" className="btn btn-light" data-bs-dismiss="modal" onClick={handleDismissButtonClick}>Thoát</button>
              <button 
                  type="submit" 
                  disabled={!canSubmit}
                  title={
                    props.isVideoUploading
                      ? 'Video đang tải lên'
                      : isDocumentUploading
                        ? 'Tài liệu đang tải lên'
                        : hasPublishData
                          ? 'Nhấn để tạo học liệu'
                          : 'Cần có ít nhất một trong các dữ liệu: tiêu đề, video hoặc ảnh đại diện'
                  }
                  className="btn-light"
                  data-bs-dismiss={canSubmit ? 'modal' : undefined}
                    onClick={canSubmit ? handleDismissButtonClick : undefined}
              >
                  Xuất bản
              </button> {/* Vô hiệu hóa nút nếu urlVideo không hợp lệ */}
            </div>
        </form>
      </div>    
    )
})
